import {
  Interaction,
  StoreInteractionRequest,
  UpdateInteractionResponse,
} from "../@types/Interaction";
import { UpdateInteractionRequest } from "../@types/Posts";
import { store, destroy, update } from "../services/interactions";

export default function useInteraction() {
  async function create(
    data: StoreInteractionRequest
  ): Promise<Interaction | null> {
    return store(data);
  }

  async function doDestroy(id: number | undefined): Promise<boolean> {
    if (!id) {
      return false;
    }

    return destroy(id);
  }

  async function doUpdate(
    id: number | undefined,
    data: UpdateInteractionRequest
  ): Promise<UpdateInteractionResponse | null> {
    if (!id) {
      return null;
    }

    return update(id, data);
  }

  return {
    create,
    doDestroy,
    doUpdate,
  };
}
